import HolidayCalendarComponent from "../components/HolidayCalendar";
import useHolidayCalendar from "../hooks/useHolidayCalendar";

function HolidayCalendar(props) {
  const useHolidayCalendarProps = useHolidayCalendar(props);
  return <HolidayCalendarComponent {...useHolidayCalendarProps} />;
}

export default HolidayCalendar;
